import { defineComponent as _defineComponent } from 'vue'
import { useContext, useRouter } from '@nuxtjs/composition-api';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import PublicPortfolioSuccessModal from '@/components/partials/public-portfolio/PublicPortfolioSuccessModal.vue';
import { getPortfolioPath } from '@/utils/routes';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioConnectionsSuccessModal',
  setup(__props) {

const { $constants, $auth, $modal } = useContext();
const router = useRouter();

function handleView() {
  const link = `${getPortfolioPath($auth.user?.slug ?? '')}/connections`;
  router.push(link);
}

function handleCancel() {
  $modal.hide($constants.dynamicModals.PUBLIC_PORTFOLIO_CONNECTIONS_SUCCESS_MODAL);
}

return { __sfc: true,$constants, $auth, $modal, router, handleView, handleCancel, BravadoButtonV3, PublicPortfolioSuccessModal }
}

})